import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { EmojiEvents, School } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const Achivements = ({ data }) => {
  const classes = useStyle();
  return (
    <Box my={{ xs: 9, md: 10 }} className={`text-center-md`}>
      <Typography variant="h4" component="h2">
        Achievements
      </Typography>
      <Typography variant="subtitle1">
        Milestones reached in upskilling
      </Typography>
      <Box
        className={classes.achivementBox}
        mt={{ xs: 5, md: 9 }}
        display="flex"
      >
        {data?.graduate && (
          <div>
            <div className={classes.iconBox}>
              <EmojiEvents />
            </div>
            <Chip className={classes.chip} label="Special Mention" />
          </div>
        )}

        {data?.special && (
          <div>
            <div className={classes.iconBox}>
              <School />
            </div>
            <Chip className={classes.chip} label="Tribe Graduate" />
          </div>
        )}
      </Box>
    </Box>
  );
};

export default Achivements;

const useStyle = makeStyles((theme: any) => ({
  achivementBox: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridGap: theme.spacing(2),
    justifyContent: 'center',
  },
  chip: { background: 'var(--light-blue)', color: '#fff' },
  iconBox: {
    width: 120,
    height: 120,
    backgroundColor: '#ffeeea',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    '& > svg': {
      color: '#ff884a',
      fontSize: 55,
    },
  },
  [theme.breakpoints.up('md')]: {
    achivementBox: {
      justifyContent: 'start',
      gridGap: theme.spacing(10),
    },
  },
}));
